import React from 'react';
import * as R from 'ramda';

const CustomAddonsDetails = ({
   addons,
}) => {
    
    return (
        <div className="detail-section">
            <h4 className="main-section-title">Custom Add-ons</h4>

            <div className="detail-section-grid">
                {addons.map((addon) => (
                    <div key={addon.id}
                         className={ "detail-section-grid-item" + (addons.length < 3 ? " -no-border-bottom" : "")}>
                        <p className="content-section-title -no-margin">{addon.label}</p>
                        <div className="item-value">$ {addon.price}</div>
                    </div>
                ))}
            </div>
        </div>
    );
};

export default CustomAddonsDetails;



// WEBPACK FOOTER //
// ./components/verify_receipt_common/custom_addons_details.js